<template>
  <div class="ad md-layout md-alignment-center about">
    <div
      class="md-layout-item md-size-100 md-layout travel md-alignment-center advHeader"
      :style="{ 'background-image' : getUrl() }"
    ></div>
    <div class="md-layout-item md-size-100 meTitle">{{getCurrentAdventure.title}}</div>
    <div
      class="md-layout-item md-size-100 ql-editor marg"
      v-html="getCurrentAdventure.content"
    >{{getCurrentAdventure.title}}</div>
    <LMap id="mapid3" :center="averageGeolocation" :zoom="zoom">
      <LTileLayer :url="url"></LTileLayer>
      <LMarker :key="index" v-for="(marker, index) in markersList" :lat-lng="marker"></LMarker>
    </LMap>
    <div
      :key="a.title"
      v-for="a in getArticlesForCurrentAdventure"
      class="md-layout-item md-size-70 md-layout adventure"
      @click="onArticleClikec(a)"
    >
      <div
        class="md-layout-item md-size-50 adventureImage"
        :style="{ 'background-image' : getUrlArticle(a) }"
      ></div>
      <div class="md-layout-item md-size-50 adventureMiniContent">
        <div class="contentDate">{{toDate(a.date)}}</div>
        <div class="contentTitle">
          <b>{{a.title}}</b>
        </div>
        <div class="contentBody">{{a.desc}}</div>
        <div class="contentBody">
          <img :src="getUrlCountry(a)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import * as moment from "moment";
moment.locale("fr");
export default {
  name: "travel",
  computed: {
    ...mapGetters(["getCurrentAdventure", "getArticlesForCurrentAdventure"]),
    markersList() {
      return this.getArticlesForCurrentAdventure.reduce(
        (acc, { markers }) => [
          ...acc,
          ...markers.map(({ lat, lng }) => [lat, lng])
        ],
        []
      );
    },
    averageGeolocation() {
      const data = this.getArticlesForCurrentAdventure.reduce(
        (acc, { markers }) => [
          ...acc,
          ...markers.map(({ lat, lng }) => [lat, lng])
        ],
        []
      );
      if (data.length === 1) {
        return data[0];
      }

      let x = 0.0;
      let y = 0.0;
      let z = 0.0;

      for (let coord of data) {
        let latitude = (coord[0] * Math.PI) / 180;
        let longitude = (coord[1] * Math.PI) / 180;

        x += Math.cos(latitude) * Math.cos(longitude);
        y += Math.cos(latitude) * Math.sin(longitude);
        z += Math.sin(latitude);
      }

      let total = data.length;

      x = x / total;
      y = y / total;
      z = z / total;

      let centralLongitude = Math.atan2(y, x);
      let centralSquareRoot = Math.sqrt(x * x + y * y);
      let centralLatitude = Math.atan2(z, centralSquareRoot);

      return [
        (centralLatitude * 180) / Math.PI,
        (centralLongitude * 180) / Math.PI
      ];
    }
  },
  props: ["adventure"],
  methods: {
    ...mapActions(["setCurrentArticle"]),
    toDate(ms) {
      return moment(ms).format("Do MMM YY");
    },
    onArticleClikec(a) {
      this.setCurrentArticle(a);
      this.$router.push("/article");
    },
    getUrl() {
      return `url('${this.getCurrentAdventure.image}')`;
    },
    getUrlArticle(a) {
      return `url('${a.image}')`;
    },
    getUrlCountry(a) {
      return `https://www.countryflags.io/${a.country.toLowerCase()}/flat/32.png`;
    }
  },
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      center: [47.41322, -1.219482],
      zoom: 2,
      src: null,
      options: {
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: false
      },
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    };
  }
};
</script>

<style >
.ad {
  background-color: #d4dadc !important;
}
.advHeader {
  height: 200px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
#mapid3 {
  height: 400px;
}
.marg {
  padding-left: 15vw;
  padding-right: 15vw;
  margin-top: 50px;
  margin-bottom: 50px;
}

.contentDate {
  padding-top: 10px;
  padding-right: 10px;
  text-align: right;
}
</style>
